// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NativeBalanceChange } from './NativeBalanceChange';
import {
    NativeBalanceChangeFromJSON,
    NativeBalanceChangeFromJSONTyped,
    NativeBalanceChangeToJSON,
} from './NativeBalanceChange';
import type { TokenBalanceChange } from './TokenBalanceChange';
import {
    TokenBalanceChangeFromJSON,
    TokenBalanceChangeFromJSONTyped,
    TokenBalanceChangeToJSON,
} from './TokenBalanceChange';
import type { TokenSwap } from './TokenSwap';
import {
    TokenSwapFromJSON,
    TokenSwapFromJSONTyped,
    TokenSwapToJSON,
} from './TokenSwap';

/**
 * 
 * @export
 * @interface TransactionEventSwap
 */
export interface TransactionEventSwap {
    /**
     * 
     * @type {NativeBalanceChange}
     * @memberof TransactionEventSwap
     */
    nativeInput: NativeBalanceChange;
    /**
     * 
     * @type {NativeBalanceChange}
     * @memberof TransactionEventSwap
     */
    nativeOutput: NativeBalanceChange;
    /**
     * 
     * @type {Array<TokenBalanceChange>}
     * @memberof TransactionEventSwap
     */
    tokenInputs: Array<TokenBalanceChange>;
    /**
     * 
     * @type {Array<TokenBalanceChange>}
     * @memberof TransactionEventSwap
     */
    tokenOutputs: Array<TokenBalanceChange>;
    /**
     * 
     * @type {Array<TokenBalanceChange>}
     * @memberof TransactionEventSwap
     */
    tokenFees: Array<TokenBalanceChange>;
    /**
     * 
     * @type {Array<NativeBalanceChange>}
     * @memberof TransactionEventSwap
     */
    nativeFees: Array<NativeBalanceChange>;
    /**
     * 
     * @type {Array<TokenSwap>}
     * @memberof TransactionEventSwap
     */
    innerSwaps: Array<TokenSwap>;
}

/**
 * Check if a given object implements the TransactionEventSwap interface.
 */
export function instanceOfTransactionEventSwap(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "nativeInput" in value;
    isInstance = isInstance && "nativeOutput" in value;
    isInstance = isInstance && "tokenInputs" in value;
    isInstance = isInstance && "tokenOutputs" in value;
    isInstance = isInstance && "tokenFees" in value;
    isInstance = isInstance && "nativeFees" in value;
    isInstance = isInstance && "innerSwaps" in value;

    return isInstance;
}

export function TransactionEventSwapFromJSON(json: any): TransactionEventSwap {
    return TransactionEventSwapFromJSONTyped(json, false);
}

export function TransactionEventSwapFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionEventSwap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nativeInput': NativeBalanceChangeFromJSON(json['nativeInput']),
        'nativeOutput': NativeBalanceChangeFromJSON(json['nativeOutput']),
        'tokenInputs': ((json['tokenInputs'] as Array<any>).map(TokenBalanceChangeFromJSON)),
        'tokenOutputs': ((json['tokenOutputs'] as Array<any>).map(TokenBalanceChangeFromJSON)),
        'tokenFees': ((json['tokenFees'] as Array<any>).map(TokenBalanceChangeFromJSON)),
        'nativeFees': ((json['nativeFees'] as Array<any>).map(NativeBalanceChangeFromJSON)),
        'innerSwaps': ((json['innerSwaps'] as Array<any>).map(TokenSwapFromJSON)),
    };
}

export function TransactionEventSwapToJSON(value?: TransactionEventSwap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nativeInput': NativeBalanceChangeToJSON(value.nativeInput),
        'nativeOutput': NativeBalanceChangeToJSON(value.nativeOutput),
        'tokenInputs': ((value.tokenInputs as Array<any>).map(TokenBalanceChangeToJSON)),
        'tokenOutputs': ((value.tokenOutputs as Array<any>).map(TokenBalanceChangeToJSON)),
        'tokenFees': ((value.tokenFees as Array<any>).map(TokenBalanceChangeToJSON)),
        'nativeFees': ((value.nativeFees as Array<any>).map(NativeBalanceChangeToJSON)),
        'innerSwaps': ((value.innerSwaps as Array<any>).map(TokenSwapToJSON)),
    };
}

